import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const propTypes = {
  /** Additional classes. */
  className: PropTypes.string,
  /** Accordion sections */
  children: PropTypes.any.isRequired,
};

const defaultProps = {
  className: '',
};

/**
 * Panel
 */
const Panel = (props) => {
  const { className, children, ...otherProps } = props;
  const classNames = classnames('panel', className);

  return (
    <div className={classNames} {...otherProps}>
      {children}
    </div>
  );
};
Panel.propTypes = propTypes;
Panel.defaultProps = defaultProps;

/**
 * Panel title
 */
Panel.Title = (props) => {
  const { className, children, ...otherProps } = props;
  const classNames = classnames('panel__title', className);

  return (
    <div className={classNames} {...otherProps}>
      {children}
    </div>
  );
};
Panel.Title.propTypes = propTypes;
Panel.Title.defaultProps = defaultProps;

/**
 * Panel content
 */
Panel.Content = (props) => {
  const { className, children, actions, ...otherProps } = props;
  const classNames = classnames('panel__content', className, { panel__actions: actions });

  return (
    <div className={classNames} {...otherProps}>
      {children}
    </div>
  );
};
Panel.Content.propTypes = {
  ...propTypes,
  actions: PropTypes.bool,
};
Panel.Content.defaultProps = {
  ...defaultProps,
  actions: false,
};

export { Panel };
